import { ModuleRegistry } from "seneca-common/features/module/registry";

import { MODULE_TYPE, TYPE } from "./consts";
import { markAnswer } from "./logic/answers";
import { getModuleAssets, transformModuleAssets } from "./logic/assets";
import { generateContent } from "./logic/content";

export type { TYPE };

export { MODULE_TYPE, transformModuleAssets };

export const register = (moduleRegistry: ModuleRegistry) =>
  moduleRegistry
    .buildModule(MODULE_TYPE)
    .with.logic()
    .markAnswer(markAnswer)
    .generateContent(generateContent)
    .getModuleAssets(getModuleAssets)
    .back.staticInformation()
    .displayName("Concept")
    .readOnly()
    .root.register();
